<template>
  <v-dialog v-model="open" width="500">
    <v-card>
      <v-card-title>
        Update Satisfaction Level
      </v-card-title>
      <v-card-text>
        <v-select item-text="text" item-value="score" v-model="clientScore" label="Select satisfaction level"
                  :items="items"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn v-if="!loading" color="primary" text :disabled="clientScore === currentSatisfactionLevel"
               @click="update">
          Update
        </v-btn>
        <v-progress-circular v-if="loading" indeterminate :size="20" color="primary"/>
        <v-btn v-if="!loading" color="primary" text @click="close">
          Cancel
        </v-btn>
        <v-progress-circular v-if="loading" indeterminate :size="20" color="primary"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../services/support.api';
import {mapActions} from "vuex";
import i18n from '../../setup/locale/en';

export default {
  props: {
    isOpen: Boolean,
    clientId: Number,
    currentSatisfactionLevel: Number,
  },
  watch: {
    isOpen(newValue) {
      this.open = newValue;
    },
    open(newValue, prevValue) {
      if (prevValue && !newValue) {
        this.close();
      }
    },
    currentSatisfactionLevel(newValue) {
      this.clientScore = newValue;
    }
  },
  data: () => ({
    loading: false,
    open: false,
    clientScore: null,
    items: [{
      score: 0, text: i18n.clients.healthScore.labels.sad,
    }, {
      score: 5, text: i18n.clients.healthScore.labels.neutral,
    }, {
      score: 10, text: i18n.clients.healthScore.labels.happy,
    }]
  }),
  mounted() {
    this.clientScore = this.currentSatisfactionLevel;
    this.open = this.isOpen;
  },
  methods: {
    ...mapActions('clientStore', ['updateSatisfactionLevel']),
    ...mapActions("whizeosupportToolsStore", ["SHOW_SNACKBAR"]),
    async update() {
      this.loading = true;
      try {
        const result = await api.saveSatisfactionLevel(this.clientId, this.clientScore);
        await this.updateSatisfactionLevel({
          clientId: this.clientId,
          satisfactionLevel: result.satisfactionLevel,
          dateUpdated: result.dateUpdated
        });
        this.close();
      } catch (error) {
        const errorMessage = {
          visible: true,
          color: "error",
          message: i18n.clients.healthScore.errors.errorUpdating,
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close');
      this.clientScore = this.currentSatisfactionLevel;
    }
  }
}
</script>
